import type { AxiosError } from 'axios';
import axiosInstance from '../lib/axios';
import type { ApiResponse } from './api';

export interface ReferralMe {
  referralCode: string;
  link: string;
  registeredCount: number;
  qualifiedCount: number;
  alreadyReferred: boolean;
  promptDismissed: boolean;
  hasActiveCampaign: boolean;
}

async function call<T>(
  request: () => Promise<{ data: { data?: T } }>,
  fallback: string
): Promise<ApiResponse<T>> {
  try {
    const response = await request();
    return { success: true, data: response.data.data as T };
  } catch (error) {
    const body = (error as AxiosError<{ message?: string; error?: string }>).response?.data;
    return { success: false, error: body?.error || body?.message || fallback };
  }
}

export const getReferralMe = () =>
  call<ReferralMe>(() => axiosInstance.get('/v1/referrals/me'), 'Failed to load referral info');

export const claimReferral = (code: string) =>
  call<{ claimed: boolean }>(
    () => axiosInstance.post('/v1/referrals/claim', { code }),
    'Failed to apply referral code'
  );

export const dismissReferralPrompt = () =>
  call<{ dismissed: boolean }>(
    () => axiosInstance.post('/v1/referrals/prompt/dismiss'),
    'Failed to dismiss'
  );
